export default "__VITE_ASSET__CkRRaXVh__"